var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['text-link', _vm.color]},[_c('Typography',{attrs:{"type":"button","typelevel":"1","sptype":"button","sptypelevel":"2"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }